// extracted by mini-css-extract-plugin
module.exports = {"cart-icon":"bd_dw","cartIcon":"bd_dw","badge":"bd_dx"};